/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .table-wrapper {
    &.table-fixed-header {
      overflow-y: auto;

      > .table {
        border-collapse: separate;
      }
    }

    &.table-fixed-columns {
      overflow-x: auto;

      > .table {
        border-collapse: separate;
      }
    }
  }

  th.wrap-cell,
  td.wrap-cell {
    white-space: pre-wrap !important;
  }

  th.no-wrap-cell,
  td.no-wrap-cell {
    white-space: nowrap;
  }

  .object-table-cell > .field > .form-group {
    margin: 0;
  }
`;
